import React from "react";
import {
  Button,
  Card,
  CardActions,
  CardTitle,
  SelectField,
  TextField,
} from "react-md";
import CenteredSection from "../../common/components/CenteredSection";
import { Redirect } from "react-router-dom";

export default class LoginForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      username: this.props.username || "",
      password: "",
      location: this.props.location || "",
      mode: this.props.mode || "",
    };

    this.modes = [
      {
        name: "Staff",
        value: "staff",
      },
      {
        name: "Registration",
        value: "registration",
      },
    ];

    this.submitLogin = this.submitLogin.bind(this);
    this.onFormChange = this.onFormChange.bind(this);
    this.onLocationChange = this.onLocationChange.bind(this);
    this.onModeChange = this.onModeChange.bind(this);
  }

  submitLogin() {
    const { username, password, location, mode } = this.state;
    this.props.onLogin(username, password, location, mode);
  }

  onFormChange(value, event) {
    this.setState({
      [event.target.name]: value,
    });
  }

  onModeChange(value, index, e) {
    this.setState({
      mode: value,
    });
  }

  onLocationChange(value, index, e) {
    this.setState({
      location: value,
    });
  }

  render() {
    const {
      loginFailedMessage,
      locations = {},
      user = null,
      username = "",
      mode = "",
      location = "",
    } = this.props;

    // Format locations into an array the dropdown can use
    const formattedLocations = Object.keys(locations).map((key) => ({
      name: locations[key].name,
      value: key,
    }));

    // Redirect the user if already logged in.
    if (user && mode) {
      return <Redirect to={`/${mode}`} />;
    }

    return (
      <CenteredSection size={4} offset={4} className="login-page">
        <Card>
          <CardTitle title="Range Manager" subtitle="Login" />
          <section className="md-grid">
            {loginFailedMessage}
            <TextField
              label="Username"
              id="username"
              name="username"
              defaultValue={username || ""}
              className="md-cell md-cell--12"
              onChange={this.onFormChange}
            />
            <TextField
              label="Password"
              type="password"
              id="password"
              name="password"
              className="md-cell md-cell--12"
              onChange={this.onFormChange}
            />
            <SelectField
              id="location"
              name="location"
              label="Location"
              placeholder="Select a Location"
              menuItems={formattedLocations}
              itemLabel="name"
              itemValue="value"
              helpOnFocus
              helpText="Select which location you are at."
              required
              onChange={this.onLocationChange}
              defaultValue={location || ""}
              className="md-cell md-cell--12"
            />
            <SelectField
              id="mode"
              name="mode"
              label="Mode"
              placeholder="Select a Mode"
              menuItems={this.modes}
              itemLabel="name"
              itemValue="value"
              helpOnFocus
              helpText="Select which mode you wish to use."
              required
              onChange={this.onModeChange}
              defaultValue={mode || ""}
              className="md-cell md-cell--12"
            />
          </section>
          <CardActions>
            <Button
              raised
              primary
              onClick={this.submitLogin}
              style={{ marginLeft: "auto" }}
            >
              Login
            </Button>
          </CardActions>
        </Card>
      </CenteredSection>
    );
  }
}



// WEBPACK FOOTER //
// ./src/login/components/LoginPage.jsx